import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import rolesReducer from './slices/rolesSlice';
import usersReducer from './slices/usersSlice';
import patientsReducer from './slices/patientsSlice';
import inquiryReducer from './slices/inquirySlice';
import consentReducer from './slices/consentSlice';
import injectionsReducer from './slices/injectionsSlice';
import personalBelongingsReducer from './slices/personalBelongingsSlice';
import tentativeFamilyPlanReducer from './slices/tentativeFamilyPlanSlice';
import sanaNotesReducer from './slices/sanaNotesSlice';
import nursingRecordsReducer from './slices/nursingRecordsSlice';
import progressNotesReducer from './slices/progressNotesSlice';
import familyMeetingMinutesReducer from './slices/familyMeetingMinutesSlice';
import depotInjectionChartsReducer from './slices/depotInjectionChartsSlice';
import vitalsReducer from './slices/vitalsSlice';
import incidentReportsReducer from './slices/incidentReportsSlice';
import medicationSheetsReducer from './slices/medicationSheetsSlice';
import prosAssessmentsReducer from './slices/prosAssessmentsSlice';
import dischargeAdviceReducer from "./slices/dischargeAdviceSlice";
import dischargeSummaryReducer from "./slices/dischargeSummarySlice";
import adlRecordsReducer from "./slices/adlRecordsSlice";
import individualisedRehabPlanReducer from './slices/individualisedRehabPlanSlice';
import casesReducer from './slices/casesSlice';
import bdiAssessmentsReducer from './slices/bdiAssessmentsSlice';
import bprsAssessmentsReducer from './slices/bprsAssessmentsSlice';
import phqAssessmentsReducer from './slices/phqAssessmentsSlice';
import ocdAssessmentsReducer from './slices/ocdAssessmentsSlice';
import qolAssessmentsReducer from './slices/qolAssessmentsSlice';
import ymrsAssessmentsReducer from './slices/ymrsAssessmentsSlice';
import suicideIntentReducer from './slices/suicideIntentSlice';
import anxietyReducer from './slices/anxietySlice';
import psychiatricFormReducer from './slices/psychiatricFormSlice';
import complaintFormReducer from './slices/complaintFormSlice';
import healthSafetyFormReducer from './slices/healthSafetyFormSlice';
import treatmentPlanReducer from './slices/treatmentPlanSlice';
import lamaFormsReducer from './slices/lamaFormsSlice';
import referralFormsReducer from './slices/referralFormsSlice';
import relocationFormsReducer from './slices/relocationFormsSlice';
import safetyPlansReducer from './slices/safetyPlansSlice';
import suicideDetailsReducer from './slices/suicideDetailsSlice';
import violenceRisksReducer from './slices/violenceRisksSlice';
import safetyPlansUrduReducer from './slices/safetyPlansUrduSlice';
import exerciseSchedulesReducer from './slices/exerciseSchedulesSlice';
import integratedAssessmentReducer from './slices/integratedAssessmentSlice';
import nursingOPDAssessmentsReducer from './slices/nursingOPDAssessmentsSlice';
import doctorOPDAssessmentsReducer from './slices/doctorOPDAssessmentsSlice';
import dashboardReducer from './slices/dashboardSlice';
import reportReducer from './slices/reportSlice';
import sessionReducer from './slices/sessionSlice';
import sessionCategoryReducer from './slices/sessionCategorySlice';
import subSessionReducer from './slices/subSessionSlice';
import userSessionReducer from './slices/userSessionSlice';
import escortFormsReducer from './slices/escortFormSlice';
import homeVisitClinicalRecordsReducer from './slices/homeVisitClinicalRecordSlice';
import clientMovementFormsReducer from './slices/clientMovementFormSlice';
import cros3FormsReducer from './slices/cros3FormSlice';
import caseManagementsReducer from './slices/caseManagementSlice';
import progressNotePrpReducer from './slices/progressNotePrpSlice';
import individualClientFileReducer from './slices/individualClientFileSlice';
import individualRehabPlanTwoReducer from './slices/individualRehabPlanTwoSlice';
import leapParticipationConsentReducer from './slices/leapParticipationConsentSlice';
import transitionFormReducer from './slices/transitionFormSlice';
import clientFeedbackReducer from './slices/clientFeedbackSlice';
import familyFeedbackReducer from './slices/familyFeedbackSlice';
import drpClientFeedbackReducer from './slices/drpClientFeedbackSlice';
import logReducer from './slices/logSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    roles: rolesReducer,
    users: usersReducer,
    patients: patientsReducer,
    inquiries: inquiryReducer,
    consent: consentReducer,
    injections: injectionsReducer,
    personalBelongings: personalBelongingsReducer,
    tentativeFamilyPlan: tentativeFamilyPlanReducer,
    sanaNotes: sanaNotesReducer,
    nursingRecords: nursingRecordsReducer,
    progressNotes: progressNotesReducer,
    familyMeetingMinutes: familyMeetingMinutesReducer,
    depotInjectionCharts: depotInjectionChartsReducer,
    vitals: vitalsReducer,
    incidentReports: incidentReportsReducer,
    medicationSheets: medicationSheetsReducer,
    prosAssessments: prosAssessmentsReducer,
    dischargeAdvice: dischargeAdviceReducer,
    dischargeSummary: dischargeSummaryReducer,
    adlRecords: adlRecordsReducer,
    individualisedRehabPlan: individualisedRehabPlanReducer,
    cases: casesReducer,
    bdiAssessments: bdiAssessmentsReducer,
    bprsAssessments: bprsAssessmentsReducer,
    phqAssessments: phqAssessmentsReducer,
    ocdAssessments: ocdAssessmentsReducer,
    qolAssessments: qolAssessmentsReducer,
    ymrsAssessments: ymrsAssessmentsReducer,
    suicideIntent: suicideIntentReducer,
    anxiety: anxietyReducer,
    psychiatricForm: psychiatricFormReducer,
    complaintForm: complaintFormReducer,
    healthSafetyForm: healthSafetyFormReducer,
    treatmentPlan: treatmentPlanReducer,
    lamaForms: lamaFormsReducer,
    referralForms: referralFormsReducer,
    relocationForms: relocationFormsReducer,
    safetyPlans: safetyPlansReducer,
    suicideDetails: suicideDetailsReducer,
    violenceRisks: violenceRisksReducer,
    safetyPlansUrdu: safetyPlansUrduReducer,
    exerciseSchedules: exerciseSchedulesReducer,
    integratedAssessments: integratedAssessmentReducer,
    nursingOPDAssessments: nursingOPDAssessmentsReducer,
    doctorOPDAssessments: doctorOPDAssessmentsReducer,
    dashboard: dashboardReducer,
    reports: reportReducer,
    sessions: sessionReducer,
    sessionCategories: sessionCategoryReducer,
    subSessions: subSessionReducer,
    userSessions: userSessionReducer,
    escortForms: escortFormsReducer,
    homeVisitClinicalRecords: homeVisitClinicalRecordsReducer,
    clientMovementForms: clientMovementFormsReducer,
    cros3Forms: cros3FormsReducer,
    caseManagements: caseManagementsReducer,
    progressNotePrp: progressNotePrpReducer,
    individualClientFile: individualClientFileReducer,
    individualRehabPlanTwo: individualRehabPlanTwoReducer,
    leapParticipationConsent: leapParticipationConsentReducer,
    transitionForm: transitionFormReducer,
    clientFeedback: clientFeedbackReducer,
    familyFeedback: familyFeedbackReducer,
    drpClientFeedback: drpClientFeedbackReducer,
    logs: logReducer,
  },
});
